window.addEventListener('load', function () {
    if (window.requestIdleCallback) {
        requestIdleCallback(function () {
          if (window.dom_attentive) {
            document
              .querySelector('.js-attentive-trigger')
              ?.addEventListener('click', function () {
                if (window.innerWidth >= 750) {
                  //call the desktop creative

                  window.__attentive.trigger(
                    null,
                    null,
                    null,
                    parseInt(window.dom_attentive.desktop_trigger)
                  )
                } else {
                  //call the mobile creative

                  window.__attentive.trigger(
                    null,
                    null,
                    null,
                    parseInt(window.dom_attentive.mobile_trigger)
                  )
                }
              })
          }
        })
    }
});
